import './ManageAuditioneesTab.css';
import './OrganisationMembers.css';

import { collection, deleteDoc, doc, getDoc, getDocs, orderBy, query, setDoc, where } from "firebase/firestore";
import SubTabParent from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabParent";
import SubTabSection from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabSection";
import { db } from "../../../../_shoru_shared_library/firebase/firebase_setup";
import { useEffect, useState } from "react";
import SectionLoader from "../../../../_shoru_shared_library/loaders/SectionLoader";
import FormInput from '../../../../_shoru_shared_library/components/form/FormInput';
import { CopyAll, DeleteOutline } from '@mui/icons-material';



export default function OrganisationMembers({userData, projectData, accentColour}) {


  const [members, setMembers] = useState(null);
  const [invites, setInvites] = useState(null);

  const [filteredMembers, setFilteredMembers] = useState(null);
  const [search, setSearch] = useState('');
  const [selected, setSelected] = useState(null);
  const [working, setWorking] = useState(false);


  const toggleAdmin = async(uid) => {
    setWorking(true)
    try {
      const docRef = doc(db, 'users', uid);
      const snap = await getDoc(docRef);
      const data = snap.data();
      const newData = {
        ...data,
        organisations: data.organisations.map((x) => 
          x.id === userData.active_organisation_id 
          ? {...x, admin: !x.admin}
          : x
        )
      }
      await setDoc(docRef, newData, {merge: true});
      setSelected(null);
      setMembers(null);
    }
    catch(err) {
      console.error(err);
      alert('Could not change admin status. Please try again.');
    }
    finally {
      setWorking(false);
    }
  }

  const revokeMembership = async(uid) => {
    setWorking(true);
    try {
      const docRef = doc(db, 'users', uid);
      const snap = await getDoc(docRef);
      const data = snap.data();

      const newOrgMemberships = data.organisation_memberships.filter(x => x !== userData.active_organisation_id);

      const newData = {
        ...data,
        organisations: data.organisations.filter(x => newOrgMemberships.includes(x.id)),
        organisation_memberships: newOrgMemberships,
        active_organisation_id: (
          data.active_organisation_id !== userData.active_organisation_id 
          ? data.active_organisation_id
          : (
              newOrgMemberships.length > 0 
              ? newOrgMemberships[0]
              : null
            )
        )
      }

      await setDoc(docRef, newData, {merge: true});
      setSelected(null);
      setMembers(null);
    }
    catch(err) {
      console.error(err);
      alert('Could not remove member. Please try again.')
    }
    finally {
      setWorking(false);
    }
  }

  const createInvite = async() => {
    setWorking(true);

    const invite = {
      uid: Math.floor(1000000000 + Math.random() * 9000000000).toString(),
      type: 'user'
    }

    try {
      const inviteDoc = doc(db, userData.active_organisation_id, 'project-data', 'active-invites', invite.uid);
      await setDoc(inviteDoc, invite);
      setInvites(null);
    }
    catch(err) {
      alert('Could not create invite, please try again');
      console.error(err);
    }
    finally {
      setWorking(false);
    }
  }

  const deleteInvite = async(uid) => {
    const inviteDoc = doc(db, userData.active_organisation_id, 'project-data', 'active-invites', uid);
    try {
      await deleteDoc(inviteDoc);
      setInvites(null);
    }
    catch(err) {
      console.error(err);
      alert('Coult not delete invite. Please try again.');
    }
  }

  const copyInvite = async(uid) => {
    try {
      await navigator.clipboard.writeText(`https://casting.shoru.app/invite/${userData.active_organisation_id}/${uid}`);
      alert('Invite link copied to clipboard');
    }
    catch(err) {
      console.error('Failed to copy: ', err);
      alert('Failed to copy invite link');
    }
  };


  useEffect(() => {
    async function getMembers() {
      const q = query(collection(db, 'users'), where('organisation_memberships', 'array-contains', userData.active_organisation_id));
      const snaps = await getDocs(q);
      const data = snaps.docs.map((snap) => {
        const data = snap.data();
        const orgData = data.organisations.find(x => x.id === userData.active_organisation_id);
        if(!orgData) return null;
        return {
          uid: data.uid,
          firstName: data.name,
          lastName: data.last_name ?? '',
          email: data.email,
          joined: orgData.joined ?? null,
          admin: orgData.admin,
          owner: orgData.owner ?? false
        }
      })
        .filter(Boolean)
        .sort((a, b) => {
          if (a.owner !== b.owner) return b.owner - a.owner;
          if (a.admin !== b.admin) return b.admin - a.admin;
          const fullNameA = `${a.firstName} ${a.lastName}`;
          const fullNameB = `${b.firstName} ${b.lastName}`;
          return fullNameA.localeCompare(fullNameB, undefined, {
            sensitivity: 'base'
          });
        });
      setMembers(data);
    }
    if(members === null) getMembers();
  }, [members]);

  useEffect(() => {
    if(!members) setFilteredMembers([]);

    if(!search.trim()) {
      setFilteredMembers(members);
      return;
    }

    const st = search.trim().toLowerCase();

    setFilteredMembers(members.filter((x) => 
      `${x.firstName} ${x.lastName}`.toLowerCase().includes(st)
      || x.email.includes(st)
    ));
  }, [members, search])

  useEffect(() => {
    async function getInvites() {
      setInvites(null);
      const q = query(
        collection(db, userData.active_organisation_id, 'project-data', 'active-invites'),
        where('type', '==', 'user')
      );
      const snaps = await getDocs(q);
      console.log(snaps.docs.length);
      const docs = snaps.docs.map((d) => d.data());
      setInvites(docs);
    }
    if(!invites) getInvites();
  }, [invites])


  if(members === null || filteredMembers === null || invites === null) return <SectionLoader />


  return (
    <>
      {
        selected && 
        <MemberViewer member={selected} setSelected={setSelected} toggleAdmin={toggleAdmin} revokeMembership={revokeMembership} working={working} />
      }
      <SubTabParent>
        <SubTabSection title='Invite Members' description="Members invited to create projects (see 'Manage Seasons') are added to your organisation automatically, and do NOT need to be invited here.">
          <button disabled={working} onClick={createInvite} style={{backgroundColor: working ? '#555' : accentColour}}>Create Invite</button>
          <div className='invite-list' style={{marginTop: invites.length ? '30px' : '0'}}>
            {
              invites.map((i) => (   
                  <div key={i.uid} className='invite-list-item'>
                    <div className='invite-list-name'>
                      <div>Invite {i.uid}</div>
                    </div>
                    <div>
                      <CopyAll onClick={() => copyInvite(i.uid)} className='copy-invite' />
                      <DeleteOutline onClick={() => deleteInvite(i.uid)} className='delete-invite' />
                    </div>
                  </div>
                )
              )
            }
          </div>
        </SubTabSection>
        <SubTabSection 
          title='Your Organisation' no_background 
          description={`View and manage the accounts in your organisation. Older accounts (pre-2027) may not include joining dates or last names. There are currently ${members.length} members in your organisation.`}
        >
          <FormInput value={search} setValue={setSearch} placeholder='search...' type='text' />
          <div className='auditionee-item-container'>
            {
              filteredMembers.map((m, i) => 
                <div key={`${m.uid}-${i}`} onClick={() => setSelected(m)} className='auditionee-item'>
                  <p style={{color: '#777'}}>{i+1}</p>
                  <p>{m.firstName}{`${m.lastName ? ` ${m.lastName}` : ''}`}</p>
                  <p style={{color: '#777'}}>{m.email}</p>
                  <p style={{
                    textAlign: 'end',
                    color: (
                      m.owner ? '#f6b93b'
                      : m.admin ? '#e55039'
                      : '#82ccdd'
                    )
                  }}>
                    {
                      m.owner ? 'Owner'
                      : m.admin ? 'Admin'
                      : 'Member'
                    }
                  </p>
                </div>
              )
            }
          </div>
        </SubTabSection>
      </SubTabParent>
    </>
  )

}


function MemberViewer({member:m, setSelected, toggleAdmin, revokeMembership, working}) {

  return (
    <div className='auditionee-overlay-container'>
      <div className='auditionee-overlay-background' onClick={() => setSelected(null)}>
        <div className='auditionee-overlay-menu' onClick={(e) => e.stopPropagation()}>
          <h2>{m.firstName}{m.lastName ? ` ${m.lastName}` : ''}</h2>
          <p className='auditionee-overlay-contacts'>{m.email} | <span style={{color: m.owner ? '#f6b93b' : m.admin ? '#e55039' : '#82ccdd'}}>{m.owner ? 'Owner' : m.admin ? 'Admin' : 'Member'}</span></p>
          <p className='auditionee-overlay-contacts'>
            {
              m.joined 
              ? `Joined: ${m.joined}`
              : `This is an older account, so we aren't sure when ${m.firstName} joined your organisation`
            }
          </p>
          {
            m.owner 
            ? <p className='auditionee-overlay-contacts'>
                {m.email} is the organisation owner, and cannot be removed.
              </p>
            : 
              <>
                <div style={{display: 'flex', flexWrap: 'wrap', gap: '12px'}}>
                  <button disabled={working} onClick={() => toggleAdmin(m.uid)} style={{
                    color: working ? '#555' : m.admin ? '#82ccdd' : '#f8c291',
                    borderColor: working ? '#555' : m.admin ? '#82ccdd' : '#f8c291',
                    border: '1px solid',
                    backgroundColor: 'transparent'
                  }}>{m.admin ? 'Revoke Admin' : 'Make Admin'}</button>
                  <button onClick={() => revokeMembership(m.uid)} style={{
                    color: working ? '#555' : '#e74c3c',
                    border: working ? '1px solid #555' : '1px solid #e74c3c',
                    backgroundColor: 'transparent'
                  }}>Remove</button>
                </div>
              </>
          }
        </div>
      </div>
    </div>
  )

}